import React from "react";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { getAccountingBasisLabel } from "@common/helpers/accountingBasis";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "./EntityBasisFilter.module.scss";

const bases = Object.values(AccountingLedgerBasis);

const basesSet: ReadonlySet<string> = new Set(bases);

const options: FilterMultiselectOption[] = bases.map((v) => ({
    value: v,
    label: getAccountingBasisLabel(v),
    searchableLabel: getAccountingBasisLabel(v),
}));

export const EntityBasisFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = filters.entityBases ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const filtered = val.filter(
                        (v): v is AccountingLedgerBasis =>
                            basesSet.has(String(v)),
                    );
                    onChange({
                        entityBases: filtered.length > 0 ? filtered : undefined,
                    });
                }}
                name="entityBases"
                onBlur={noop}
            />
        </div>
    );
};
